import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CompanyPageStepClientBusComponent } from './company-page-step-client-bus.component';

@NgModule({
  declarations: [CompanyPageStepClientBusComponent],
  imports: [
    CommonModule,
    PopoverModule.forRoot(),
    TooltipModule.forRoot()
  ],
  exports: [CompanyPageStepClientBusComponent],
  entryComponents: [CompanyPageStepClientBusComponent]
})
export class CompanyPageStepClientBusModule { }
